import { checkPointInViewport, convertToLayerPoint } from '@/framework';
import { Framework } from '@/framework/instance';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { parseWsKey } from '../../utils';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 移动光标
 */
export class MoveCursor extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.MoveCursor, this.onReceiveMoveCursor.bind(this));
    }

    send(stageIndex: number, x: number, y: number) {
        const originIndex = this.framework.convertStageToOrigin(stageIndex);
        this.room.throttleSendToAll(OperateType.MoveCursor, [originIndex, x, y], false, 50, (data: number[]) => {
            const mPoint = { x: data[1], y: data[2] };
            if (checkPointInViewport(this.identity, mPoint)) {
                const point = convertToLayerPoint(this.identity, mPoint, stageIndex);
                const size = this.framework.getSize(data[0]);
                data[1] = point.x / size.width;
                data[2] = point.y / size.height;
            } else {
                data[1] = Number.MIN_VALUE;
                data[2] = Number.MIN_VALUE;
            }
            this.collaborators.getMember()?.setCursorInfo(originIndex, data[1], data[2]);
            return true;
        });
    }

    checkNeedRender(x: number, y: number) {
        return x !== Number.MIN_VALUE && y !== Number.MIN_VALUE;
    }

    private onReceiveMoveCursor({ fromWsMemberKey, data }: IEditMessage<number[]>) {
        const { wsKey } = parseWsKey(fromWsMemberKey);
        const [originIndex, x, y] = data;
        this.collaborators.getMember(wsKey)?.setCursorInfo(originIndex, x, y);
        this.room.renderUserCursor();
    }
}
